export enum ETrainingTabs {
  DEVELOPMENT = "development",
  CYBERNETICS = "cybernetics",
  REDISTRIBUTION = "redistribution",
}
